<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindow cdkDrag [windowMovable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">{{title}}</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="message">
        <div class="messages">
          <div [style.display]=iconVisibleFlg>
            <fa-icon [icon]="messageIcon" class="{{messageIconStyleClass}}"></fa-icon>&nbsp;&nbsp;
          </div>
          <div>
          <ng-template ngFor let-item [ngForOf]="textList">
              <span class="message-text">{{item}}</span><br>
            </ng-template>
        </div>
        </div>
      </div>
      <div class="buttons">
        <ng-template ngFor let-item [ngForOf]="buttonList">
          <button class="btn-secondary" type="button" id="pless-alert-button-{{item.id}}" (click)="onClick(item.id)" (keydown.Tab)="onKeyTab($event,item.id,false)"
            (keydown.shift.tab)="onKeyTab($event,item.id,true)" (clickOutside)="onClickedOutside($event)" tabindex="{{item.id}}">{{item.label}}</button>
        </ng-template>
      </div>
      <div cdkDragHandle class="drag-subwindow-bottom-area"></div>
    </td>
  </tr>
</table>
